import { SEARCH_NAMES } from "constant/search/search";
import { getObjectTypeValues } from "type/common/type_util";

export const DL_GROUP_SLUG = {
  PetarLubarda: "petar-lubarda",
  SavaSumanovic: "sava-sumanovic",
  NadezdaPetrovic: "nadezda-petrovic",
  MuzejSavremeneUmetnosti: "muzej-savremene-umetnosti",
  Avangarda: "avangarda",
  OktobarskiSalon: "oktobarski-salon",
  KonceptualnaUmetnost: "konceptualna-umetnost",
} as const;

const dlGroupSlugs = getObjectTypeValues(DL_GROUP_SLUG);

export type DlGroupSlug = (typeof dlGroupSlugs)[number];

export const DL_GROUP_PER_PAGE_MAX = 10;

export const GROUP_SEARCH_OPTIONS = [
  SEARCH_NAMES.SEARCH_TEXT,
  SEARCH_NAMES.LIMIT,
  SEARCH_NAMES.SKIP,
  SEARCH_NAMES.GROUP_SLUG,
] as const;

export type GroupSearchOptions = (typeof GROUP_SEARCH_OPTIONS)[number];
